import type Language from '../../../types/Language';

const getLanguageByCode = (code: string): Language => {
  return {
    code,
    label: `common.language.${code}`,
  };
};

export default getLanguageByCode;
